// import SmallBanner from "@components/common/SmallBanner";
import Text from "@components/common/Text";
import Title from "@components/common/Title";
import Layout from "@components/layouts/Layout";
import Products from "@components/sections/Products";
import ProductsNew from "@components/sections/products2/Products";
import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import {
    TbCircleNumber1,
    TbCircleNumber2,
    TbCircleNumber3,
    TbCircleNumber4,
} from "react-icons/tb";
import useSWR from "swr";
import HeroSection from "../../../components/newVersion/HeroSection";

const endpoints = {
    products: "/.netlify/functions/products",
};

const fetcher = ([url, body]) => axios.post(url, body).then((res) => res);

const Tienda = () => {
    const categories = ["interviews"];

    const {
        data: result,
        // error,
        isLoading,
        isValidating,
    } = useSWR(
        categories ? [endpoints.products, { filters: categories }] : null,
        fetcher,
        {
            dedupingInterval: 30000, // evita peticiones duplicadas durante 30s
        },
    );

    const [filteredItems, setFilteredItems] = useState([]);

    const [mossosF1P, setMossosF1P] = useState([]);
    const [mossosF2P, setMossosF2P] = useState([]);
    const [mossosF3P, setMossosF3P] = useState([]);
    const [mossosF4P, setMossosF4P] = useState([]);

    const [, setMossosF1O] = useState([]);
    const [, setMossosF2O] = useState([]);
    const [, setMossosF3O] = useState([]);
    const [, setMossosF4O] = useState([]);

    // const [mossosOnlineItems, setMossosOnlineItems] = useState([]);
    // const [mossosPresencialItems, setMossosPresencialItems] = useState([]);
    // const [plOnlineItems, setPlOnlineItems] = useState([]);
    const [, setPlPresencialItems] = useState([]);

    const [plF1P, setPlF1P] = useState([]);
    const [plF2P, setPlF2P] = useState([]);

    const [arroBrimoCaporalsF1P, setArroBrimoCaporalsF1P] = useState([]);
    const [arroBrimoCaporalsF2P, setArroBrimoCaporalsF2P] = useState([]);

    useEffect(() => {
        // Filtramos y ordenamos los productos
        const items = result?.data?.products
            ?.filter((x) => x.enabled && !x.hidden)
            // Convertimos fechas
            .map((p) => {
                const { created_at, updated_at, ...rest } = p;
                return {
                    ...rest,
                    created_at: dayjs(created_at).toDate(),
                    updated_at: dayjs(updated_at).toDate(),
                };
            })
            // Ordenamos por stock y luego por fecha
            .sort((a, b) => b.stock - a.stock || b.created_at - a.created_at);

        setFilteredItems(items);
    }, [result]);

    useEffect(() => {
        setMossosF1P(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("mossos") &&
                    x.category?.includes("face-to-face") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase1"),
            ) || [],
        );

        setMossosF2P(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("mossos") &&
                    x.category?.includes("face-to-face") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase2"),
            ) || [],
        );

        setMossosF3P(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("mossos") &&
                    x.category?.includes("face-to-face") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase3"),
            ) || [],
        );

        setMossosF4P(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("mossos") &&
                    x.category?.includes("face-to-face") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase4"),
            ) || [],
        );

        setMossosF1O(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("mossos") &&
                    x.category?.includes("online") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase1"),
            ) || [],
        );

        setMossosF2O(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("mossos") &&
                    x.category?.includes("online") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase2"),
            ) || [],
        );

        setMossosF3O(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("mossos") &&
                    x.category?.includes("online") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase3"),
            ) || [],
        );

        setMossosF4O(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("mossos") &&
                    x.category?.includes("online") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase4"),
            ) || [],
        );

        setPlPresencialItems(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("pl") &&
                    x.category?.includes("face-to-face") &&
                    x.category.includes("interviews"),
            ) || [],
        );

        setPlF1P(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("pl") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase1"),
            ) || [],
        );

        setPlF2P(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("pl") &&
                    x.category.includes("interviews") &&
                    x.category?.includes("fase2"),
            ) || [],
        );

        setArroBrimoCaporalsF1P(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("arro") &&
                    x.category?.includes("fase1"),
            ) || [],
        );

        setArroBrimoCaporalsF2P(
            filteredItems?.filter(
                (x) =>
                    x.category?.includes("arro") &&
                    x.category?.includes("fase2"),
            ) || [],
        );
    }, [filteredItems]);

    return (
        <>
            <Layout
                seo={{
                    title: "Nuestra tienda: Entrevistas",
                    description:
                        "Simulamos entrevistas reales y trabajamos tus respuestas para que transmitas seguridad, claridad y convicción ante el tribunal.",
                    image: "https://www.iopos.es/images/bgs/bgEntrevistas3.jpg",
                }}
                mode="fixed"
            >
                <HeroSection
                    filename={"bgs/bgEntrevistas3"}
                    firstTitle={"Entrevistas"}
                    secondTitle={"Preparación personalizada"}
                    thirdTitle={
                        "Simulamos entrevistas reales y trabajamos tus respuestas para que **transmitas seguridad, claridad y convicción** ante el tribunal."
                    }
                    showScrollDownIcon={true}
                />

                <div className="container space-y-10 py-20 lg:px-0">
                    {/** Mossos Presenciales / Online */}
                    <section className="" id="mossos">
                        <Title>
                            Mossos d&apos;Esquadra - Presenciales / Online
                        </Title>
                        <Text className="text-justify">
                            Sabemos que tipologia de entrevista tendrás y qué
                            busca exactamente el tribunal. En nuestro curso
                            presencial de preparación a Mossos d&apos;Esquadra
                            te preparamos con simulaciones reales y feedback
                            personalizado. Conocemos cada detalle del proceso de
                            selección para ayudarte a destacar y conseguir la
                            máxima puntuación.
                        </Text>

                        <div className="grid grid-cols-1 gap-10">
                            {/** Fase 1 */}
                            <div className="space-y-3">
                                <h3 className="mt-10 flex flex-col gap-2 border-b-2 border-ccyan border-opacity-75 text-xl font-semibold uppercase text-ccyan-dark md:flex-row md:items-center md:gap-2">
                                    <div className="flex items-center gap-2">
                                        <span>Fase</span>
                                        <TbCircleNumber1 className="shrink-0 text-2xl" />
                                    </div>
                                    <span>
                                        Biodata, currículum y tests
                                        psicoprofesionales
                                    </span>
                                </h3>

                                <Text className="text-justify text-sm">
                                    Se realiza un curso presencial sobre
                                    biodata, currículum y tests
                                    psicoprofesionales, seguido de una sesión en
                                    directo por Zoom con un psicólogo para
                                    resolver dudas clave. Esta sesión queda
                                    grabada en el campus y los cursos
                                    presenciales se imparten en fines de semana.
                                </Text>

                                <div className="mt-10 space-y-5">
                                    {process.env.GATSBY_NEW_PRODUCTS_ENABLED ===
                                    "true" ? (
                                        <ProductsNew
                                            items={mossosF1P}
                                            loading={isLoading || isValidating}
                                        />
                                    ) : (
                                        <Products items={mossosF1P} />
                                    )}
                                </div>
                            </div>

                            {/** Fase 2 */}
                            <div className="space-y-3">
                                <h3 className="mt-10 flex flex-col gap-2 border-b-2 border-ccyan border-opacity-75 text-xl font-semibold uppercase text-ccyan-dark md:flex-row md:items-center md:gap-2">
                                    <div className="flex items-center gap-2">
                                        <span>Fase</span>
                                        <TbCircleNumber2 className="shrink-0 text-2xl" />
                                    </div>
                                    <span>Preparación para la entrevista </span>
                                </h3>

                                <Text className="text-justify text-sm">
                                    La preparación para la entrevista policial
                                    es presencial/online e individual, con una
                                    duración de 1 hora y 30 minutos, guiada por
                                    un especialista. Se trabaja la comunicación,
                                    el autoconocimiento, el currículum y la
                                    motivación, con análisis personalizado y
                                    feedback final.
                                </Text>

                                <div className="mt-16 space-y-5">
                                    {process.env.GATSBY_NEW_PRODUCTS_ENABLED ===
                                    "true" ? (
                                        <ProductsNew
                                            items={mossosF2P}
                                            loading={isLoading || isValidating}
                                        />
                                    ) : (
                                        <Products items={mossosF2P} />
                                    )}
                                </div>
                            </div>

                            {/** Fase 3 */}
                            <div className="space-y-3">
                                <h3 className="mt-10 flex flex-col gap-2 border-b-2 border-ccyan border-opacity-75 text-xl font-semibold uppercase text-ccyan-dark md:flex-row md:items-center md:gap-2">
                                    <div className="flex items-center gap-2">
                                        <span>Fase</span>
                                        <TbCircleNumber3 className="shrink-0 text-2xl" />
                                    </div>
                                    <span>Simulacro de entrevista</span>
                                </h3>

                                <Text className="text-justify text-sm">
                                    Consiste en un simulacro presencial/online e
                                    individual de una hora, donde se te evaluará
                                    desde el primer minuto como si fuera la
                                    entrevista oficial. Se trabaja con preguntas
                                    reales y competencias de la convocatoria,
                                    incluyendo un feedback final para corregir
                                    errores.
                                </Text>

                                <div className="mt-10 space-y-5">
                                    {process.env.GATSBY_NEW_PRODUCTS_ENABLED ===
                                    "true" ? (
                                        <ProductsNew
                                            items={mossosF3P}
                                            loading={isLoading || isValidating}
                                        />
                                    ) : (
                                        <Products items={mossosF3P} />
                                    )}
                                </div>
                            </div>

                            {/** Fase 4 */}
                            <div className="space-y-3">
                                <h3 className="mt-10 flex flex-col gap-2 border-b-2 border-ccyan border-opacity-75 text-xl font-semibold uppercase text-ccyan-dark md:flex-row md:items-center md:gap-2">
                                    <div className="flex items-center gap-2">
                                        <span>Fase</span>
                                        <TbCircleNumber4 className="shrink-0 text-2xl" />
                                    </div>
                                    <span>Simulacro Premium de entrevista</span>
                                </h3>

                                <Text className="text-justify text-sm">
                                    Simulacro premium presencial de una hora con
                                    evaluación individual a cargo de un
                                    psicólogo y un caporal de Mossos
                                    especialista en selección. Se utiliza una
                                    parrilla oficial de puntuación por
                                    competencias, con preguntas reales y
                                    feedback final detallado.
                                </Text>

                                <div className="mt-10 space-y-5">
                                    {process.env.GATSBY_NEW_PRODUCTS_ENABLED ===
                                    "true" ? (
                                        <ProductsNew
                                            items={mossosF4P}
                                            loading={isLoading || isValidating}
                                        />
                                    ) : (
                                        <Products items={mossosF4P} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>

                    {/** PL Presenciales / GUB / Online */}
                    <section className="" id="policia-local">
                        <Title>
                            Guàrdia Urbana de Barcelona / Policia Local
                            Presenciales / Online
                        </Title>
                        <Text className="text-justify">
                            Domina la entrevista con nuestra preparación cara a
                            cara. Sabemos cómo piensa el tribunal y cuáles son
                            las preguntas más frecuentes. En nuestras clases
                            presenciales para Policía Local y Guàrdia Urbana de
                            Barcelona, trabajarás con simulacros realistas y
                            recibirás correcciones inmediatas. Entrena en
                            condiciones reales y llega a la entrevista con
                            seguridad y ventaja.
                        </Text>

                        <div className="grid grid-cols-1 gap-10">
                            {/** Fase 1 */}
                            <div className="space-y-3">
                                <h3 className="mt-10 flex flex-col gap-2 border-b-2 border-ccyan border-opacity-75 text-xl font-semibold uppercase text-ccyan-dark md:flex-row md:items-center md:gap-2">
                                    <div className="flex items-center gap-2">
                                        <span>Fase</span>
                                        <TbCircleNumber1 className="shrink-0 text-2xl" />
                                    </div>
                                </h3>

                                <Text className="text-justify text-sm">
                                    La preparación para la entrevista policial
                                    es presencial/online e individual, con una
                                    duración de 1 hora y 30 minutos, guiada por
                                    un especialista. Se trabaja la comunicación,
                                    el autoconocimiento, el currículum y la
                                    motivación, con análisis personalizado y
                                    feedback final.
                                </Text>

                                <div className="mt-10 space-y-5">
                                    {process.env.GATSBY_NEW_PRODUCTS_ENABLED ===
                                    "true" ? (
                                        <ProductsNew
                                            items={plF1P}
                                            loading={isLoading || isValidating}
                                        />
                                    ) : (
                                        <Products items={plF1P} />
                                    )}
                                </div>
                            </div>

                            {/** Fase 2 */}
                            <div className="space-y-3">
                                <h3 className="mt-10 flex flex-col gap-2 border-b-2 border-ccyan border-opacity-75 text-xl font-semibold uppercase text-ccyan-dark md:flex-row md:items-center md:gap-2">
                                    <div className="flex items-center gap-2">
                                        <span>Fase</span>
                                        <TbCircleNumber2 className="shrink-0 text-2xl" />
                                    </div>
                                </h3>

                                <Text className="text-justify text-sm">
                                    Consiste en un simulacro presencial/online e
                                    individual de una hora, donde se te evaluará
                                    desde el primer minuto como si fuera la
                                    entrevista oficial. Se trabaja con preguntas
                                    reales y competencias de la convocatoria,
                                    incluyendo un feedback final para corregir
                                    errores.
                                </Text>

                                <div className="mt-16 space-y-5">
                                    {process.env.GATSBY_NEW_PRODUCTS_ENABLED ===
                                    "true" ? (
                                        <ProductsNew
                                            items={plF2P}
                                            loading={isLoading || isValidating}
                                        />
                                    ) : (
                                        <Products items={plF2P} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>

                    {/** Arro / Brimo / Caporals */}
                    <section className="" id="arro-brimo-caporals">
                        <Title>Arro / Brimo / Caporals / Online</Title>
                        <Text className="text-justify">
                            Domina la entrevista con nuestra preparación cara a
                            cara. Sabemos cómo piensa el tribunal y cuáles son
                            las preguntas más frecuentes. En nuestras
                            formaciones presenciales, trabajarás con simulacros
                            realistas. Entrena en condiciones reales y llega a
                            la entrevista con seguridad y ventaja.
                        </Text>

                        <div className="grid grid-cols-1 gap-10">
                            {/** Fase 1 */}
                            <div className="space-y-3">
                                <h3 className="mt-10 flex flex-col gap-2 border-b-2 border-ccyan border-opacity-75 text-xl font-semibold uppercase text-ccyan-dark md:flex-row md:items-center md:gap-2">
                                    <div className="flex items-center gap-2">
                                        <span>Fase</span>
                                        <TbCircleNumber1 className="shrink-0 text-2xl" />
                                    </div>
                                </h3>

                                <Text className="text-justify text-sm">
                                    La preparación para la entrevista policial
                                    es presencial/online e individual, con una
                                    duración de 1 hora y 30 minutos, guiada por
                                    un especialista. Se trabaja la comunicación,
                                    el autoconocimiento, el currículum y la
                                    motivación, con análisis personalizado y
                                    feedback final.
                                </Text>

                                <div className="mt-10 space-y-5">
                                    {process.env.GATSBY_NEW_PRODUCTS_ENABLED ===
                                    "true" ? (
                                        <ProductsNew
                                            items={arroBrimoCaporalsF1P}
                                            loading={isLoading || isValidating}
                                        />
                                    ) : (
                                        <Products
                                            items={arroBrimoCaporalsF1P}
                                        />
                                    )}
                                </div>
                            </div>

                            {/** Fase 2 */}
                            <div className="space-y-3">
                                <h3 className="mt-10 flex flex-col gap-2 border-b-2 border-ccyan border-opacity-75 text-xl font-semibold uppercase text-ccyan-dark md:flex-row md:items-center md:gap-2">
                                    <div className="flex items-center gap-2">
                                        <span>Fase</span>
                                        <TbCircleNumber2 className="shrink-0 text-2xl" />
                                    </div>
                                </h3>

                                <Text className="text-justify text-sm">
                                    Consiste en un simulacro presencial/online e
                                    individual de una hora, donde se te evaluará
                                    desde el primer minuto como si fuera la
                                    entrevista oficial. Se trabaja con preguntas
                                    reales y competencias de la convocatoria,
                                    incluyendo un feedback final para corregir
                                    errores.
                                </Text>

                                <div className="mt-10 space-y-5">
                                    {process.env.GATSBY_NEW_PRODUCTS_ENABLED ===
                                    "true" ? (
                                        <ProductsNew
                                            items={arroBrimoCaporalsF2P}
                                            loading={isLoading || isValidating}
                                        />
                                    ) : (
                                        <Products
                                            items={arroBrimoCaporalsF2P}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </Layout>
        </>
    );
};

export default Tienda;
